<div class="row m-3">
  <div class="col-xs-12 col-sm-12 col-md-6 mx-auto">
    <div class="card">
      <div class="card-header">
        <h3 class="card-title">
          Privaten Schlüssel ansehen
        </h3>
      </div>
      <div class="card-body" *ngIf="privateKeyDetails">
        <div class="row mb-3">
          <div class="control-label col-form-label col-5">ID</div>
          <div class="col-7">
            <p class="form-control">
              {{ privateKeyDetails.id }}
            </p>
          </div>
        </div>

        <div class="row mb-3">
          <div class="control-label col-form-label col-5">Algorithmus</div>
          <div class="col-7">
            <p class="form-control">
              {{ privateKeyDetails.algorithm }}
            </p>
          </div>
        </div>

        <div class="row mb-3">
          <div class="control-label col-form-label col-5">Seriennummer (dez/hex)</div>
          <div class="col-7">
            <p class="form-control">
              {{ privateKeyDetails.certificateDetails.certificate.serialNumber }} /
              {{ privateKeyDetails.certificateDetails.certificate.serialNumberInHex }}
            </p>
          </div>
        </div>

        <div class="row mb-3">
          <div class="control-label col-form-label col-5">Antragssteller</div>
          <div class="col-7">
            <p class="form-control">
              {{ privateKeyDetails.certificateDetails.certificate.subjectX500Principal| principalName: false }}
            </p>
          </div>
        </div>

        <div class="row mb-3">
          <div class="control-label col-form-label col-5">Aussteller</div>
          <div class="col-7">
            <a *ngIf="issuerCertificateID" [routerLink]="['/schluessel/zertifikate', issuerCertificateID]">
              {{ privateKeyDetails.certificateDetails.certificate.issuerX500Principal| principalName: false }}
            </a>
            <p *ngIf="!issuerCertificateID" class="form-control">
              {{ privateKeyDetails.certificateDetails.certificate.issuerX500Principal| principalName: false }}
            </p>
          </div>
        </div>

        <div class="row mb-3">
          <div class="control-label col-form-label col-5">Gültig von</div>
          <div class="col-7">
            <p class="form-control">
              {{ privateKeyDetails.certificateDetails.certificate.validFrom }}
            </p>
          </div>
        </div>

        <div class="row mb-3">
          <div class="control-label col-form-label col-5">Gültig bis</div>
          <div class="col-7">
            <p class="form-control">
              {{ privateKeyDetails.certificateDetails.certificate.validTo }}
            </p>
          </div>
        </div>

        <div class="row mb-3">
          <div class="control-label col-form-label col-5">Schlüssellänge</div>
          <div class="col-7">
            <p class="form-control">
              {{ privateKeyDetails.certificateDetails.keyLength }}
            </p>
          </div>
        </div>

        <div class="row mb-3">
          <div class="control-label col-form-label col-5">Fingerabdruck (SHA1)</div>
          <div class="col-7">
            <p class="form-control">
              {{ privateKeyDetails.certificateDetails.thumbprintWithSHA1 }}
            </p>
          </div>
        </div>

        <div class="row mb-3">
          <div class="control-label col-form-label col-5 word-break-word">Schlüsselverwendungen</div>
          <div class="col-7">
            <p class="form-control">
              {{ privateKeyDetails.certificateDetails.keyUsages }}
            </p>
          </div>
        </div>

        <div class="row mb-3">
          <div class="control-label col-form-label col-5 word-break-word">Erweiterte Schlüsselverwendungen</div>
          <div class="col-7">
            <p class="form-control">
              {{ privateKeyDetails.certificateDetails.extendedKeyUsages }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
